import React from 'react';
import PropTypes from 'prop-types';
import LinkButton from 'components/ui/buttons/LinkButton';
import { Row, Col } from 'components/ui/grid';
import { URLS } from 'consts';
import { useParams } from 'react-router-dom';

const SuccessNotification = ({ isReschedule, appointmentType }) => {
  const appointmentTypeCopy = <strong>{appointmentType} interview</strong>;
  const { project_id } = useParams();
  return (
    <div className="p-4 text-center">
      <h1 className="text-center fancy mb-4">
        {isReschedule ? "We've asked them to reschedule!" : 'Invite sent!'}
      </h1>
      {isReschedule ? (
        <p>We sent your invitation to reschedule the {appointmentTypeCopy}</p>
      ) : (
        <p>
          We&apos;ve sent your invitation for a {appointmentTypeCopy}
          &nbsp; to this candidate.
        </p>
      )}
      <p>
        Look out for an email confirmation once they choose a time. You can also
        find updates on your Interviews page.
      </p>
      <Row className="justify-content-end">
        <Col col="12" md="5" className="order-1 order-md-2">
          <LinkButton
            data-id="interview-request-ok-btn"
            type="button"
            className="mt-4 w-100"
            href={URLS.employerProjectBids(project_id)}
          >
            See more applicants
          </LinkButton>
        </Col>
        <Col col="12" md="4" className="order-2 order-md-1">
          <LinkButton
            data-id="interview-request-ok-btn"
            type="button"
            className="mt-4 w-100"
            href={URLS.employerHome}
            secondary
          >
            Go to dashboard
          </LinkButton>
        </Col>
      </Row>
    </div>
  );
};

SuccessNotification.propTypes = {
  isReschedule: PropTypes.bool.isRequired,
  appointmentType: PropTypes.oneOf(['phone', 'video']),
};

export default SuccessNotification;
